var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAwesomeHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.188,
    height: 26.414,
    viewBox: "0 0 30.188 26.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-heart",
    "data-name": "Icon awesome-heart",
    d: "M27.257,4.054a8.063,8.063,0,0,0-11,.8l-1.161,1.2-1.161-1.2a8.062,8.062,0,0,0-11-.8,8.466,8.466,0,0,0-.584,12.258l11.409,11.78a1.848,1.848,0,0,0,2.671,0l11.409-11.78a8.461,8.461,0,0,0-.578-12.258Z",
    transform: "translate(0.001 -2.248)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwesomeHeart);
export default __webpack_public_path__ + "static/media/Icon-awesome-heart.dd9bc9144b937ce76f67619a4c348a3c.svg";
export { ForwardRef as ReactComponent };